import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-email-change-confirmation-modal',
  standalone: false,
  templateUrl: './email-change-confirmation-modal.component.html',
  styleUrl: './email-change-confirmation-modal.component.scss'
})
export class EmailChangeConfirmationModalComponent implements OnInit {

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<EmailChangeConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  dynamicFormFields: any = this.data.value;
  safeHtmlContent!: SafeHtml; // To hold the sanitized message

  ngOnInit(): void {
    if (this.dynamicFormFields) {
      this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.dynamicFormFields);
    }
  }

  cancelClicked() {
    this.dialogRef.close();
  }

  continueClicked() {
    this.dialogRef.close('continue');
  }

}
